import { ArrowUpIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const ArrowUpBold = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ArrowUpIcon {...rest} size={Sizes[size]} color={fill} />;
};

ArrowUpBold.displayName = 'ArrowUpBold';
